<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <!-- <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户
        </router-link>
      </div> -->
      <div class="fl w-400">
        <el-input placeholder="请输入发票内容" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div><span class="m-l-30" style="color:#111;">企业：<span style="font-size:20px;font-weight:700;margin-top:7px;color:#111;">{{company_name}}</span></span>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%;"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="导入人"
      width="150">
      </el-table-column>
      <el-table-column
      prop="number"
      label="发票号码"
      fixed
      width="150">
      </el-table-column>
      <el-table-column
      prop="code"
      label="发票代码"
      :show-overflow-tooltip="true"
      width="200">
      </el-table-column>
      <el-table-column
      prop="buyer_tax_number"
      label="购买方税号"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      label="文件状态"
      width="100">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" style="color:#0c0">正常</span>
            <span v-else-if = "scope.row.status ==0"  style="color:#bb0">{{ scope.row.status | status }}</span>
            <span v-else-if = "scope.row.status ==-1" style="color:#d00">{{ scope.row.status | status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="验真状态"
      width="100">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.is_really ==1" style="color:#0c0">验真成功</span>
            <span v-else-if = "scope.row.is_really ==0" style="color:#bb0">未验真</span>
            <span v-else-if = "scope.row.is_really ==-1">验真失败</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="报销状态"
      width="100">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.bill_status >=1 && scope.row.bill_status <=5" style="color:#bb0">报销中</span>
            <span v-else-if = "scope.row.bill_status ==0" style="color:#bb0">待提交</span>
            <span v-else-if = "scope.row.bill_status ==6" style="color:#0c0">已报销</span>
            <span v-else-if = "scope.row.bill_status==-1">未报销</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      prop="day"
      label="开票日期"
      width="200">
      </el-table-column>
      <el-table-column
      prop="no_tax_money"
      label="不含税金额"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="tax_money"
      label="税额"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="money"
      label="价税合计金额"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="unit"
      label="销售方"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="project"
      label="项目名称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="buyer"
      label="购买方"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="create_time"
      label="导入时间"
      width="200">
      </el-table-column>
    <el-table-column
    label="文件预览"
    fixed="right"
    width="100">
      <template scope="scope">
        <div>
          <el-button v-if="scope.row.img_type == 2" type="success" size="small" v-on:click="ofd_detail=[];ofd_detail=scope.row;look_ofd_file=true">预览文件</el-button>
          <el-button v-if="scope.row.img_type != 2" type="success" size="small" v-on:click="img_detail=[];img_detail=scope.row;look_img_file=true">预览文件</el-button>
        </div>
      </template>
    </el-table-column>
    </el-table>
    <el-dialog title="" :visible.sync="look_ofd_file" append-to-body :close-on-click-modal="true" :show-close="false" custom-class="w-650">
      <ofdGroup :ofd_detail="ofd_detail" v-on:closeMain="look_ofd_file=false;"></ofdGroup>
    </el-dialog>
    <el-dialog title="" :visible.sync="look_img_file" append-to-body :close-on-click-modal="true" :show-close="false" custom-class="w-650">
      <imgGroup :img_detail="img_detail" v-on:closeMain="look_img_file=false;"></imgGroup>
    </el-dialog>
    <div class="pos-rel p-t-20">
      <!-- <btnGroup :selectedData="multipleSelection" :type="'bill'"></btnGroup> -->
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-bill-group.vue'
  import ofdGroup from '../../../Common/ofd.vue'
  import imgGroup from '../../../Common/image.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        look_ofd_file: false,
        look_img_file: false,
        ofd_detail: [],
        img_detail: [],
        currentPage: null,
        company_name: '',
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            id: this.$route.params.id,
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/company/company_bill_folder', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.company_name = data.company_name
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('company-save')
      },
      editShow() {
        return _g.getHasRule('company-update')
      },
      deleteShow() {
        return _g.getHasRule('company-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup,
      ofdGroup,
      imgGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// company_bill_folder.vue?73d11f4e